var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilledStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54952 29.178C7.54964 29.1779 7.54976 29.1778 7.54988 29.1777L7.54952 29.178ZM16.0843 1.4309L16.5598 1.58541L16.0843 1.4309L12.7945 11.5557H2.14863C1.47053 11.5557 1.18858 12.4235 1.73718 12.822L10.3499 19.0795L7.06012 29.2044C6.85058 29.8493 7.5887 30.3856 8.13731 29.987L16.75 23.7295L25.3627 29.987C25.9113 30.3856 26.6494 29.8493 26.4399 29.2044L23.1501 19.0795L31.7628 12.822C32.3114 12.4235 32.0295 11.5557 31.3514 11.5557H20.7055L17.4157 1.4309L16.9402 1.58541L17.4157 1.4309C17.2062 0.785992 16.2938 0.785977 16.0843 1.4309ZM16.9263 23.6014C16.9262 23.6015 16.926 23.6016 16.9258 23.6018L16.9263 23.6014Z",
    fill: "url(#paint0_linear_38_13736)",
    stroke: "url(#paint1_linear_38_13736)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_13736",
    x1: 0.75,
    y1: 17,
    x2: 32.75,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207692,
    stopColor: "#DEA64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351282,
    stopColor: "#FFEB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489744,
    stopColor: "#EFBC68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607692,
    stopColor: "#FFD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74359,
    stopColor: "#BE8D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6C0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38_13736",
    x1: 0.75,
    y1: 17,
    x2: 32.75,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207692,
    stopColor: "#DEA64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351282,
    stopColor: "#FFEB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489744,
    stopColor: "#EFBC68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607692,
    stopColor: "#FFD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74359,
    stopColor: "#BE8D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6C0C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStar);
export default __webpack_public_path__ + "static/media/filled_star.6dd6c67f106fdfdda2f42707157d7846.svg";
export { ForwardRef as ReactComponent };